import * as ActionTypes from "../actions/types";

const INITIAL_APP_STATE = {
  clientId: null,
  clientSecret: null,
  loading: false,
  errorMessage: null,
};

const INITIAL_STATE = {
  activeDirectory: "/",
  loading: false,
  receiveStatus: true,
  application: INITIAL_APP_STATE,
  forum_topic: {
    subject: null,
    body: null,
  },
};

function resetTerminalApplication(state) {
  return {
    ...state,
    application: { ...INITIAL_APP_STATE },
  };
}

function createTerminalApplication(state) {
  return {
    ...state,
    application: {
      ...state.application,
      errorMessage: null,
      loading: true,
    },
  };
}

function createTerminalApplicationSuccess(state, action) {
  // New API only returns applicationId, not the full details with credentials
  // Terminal will need to fetch the application details separately if needed
  return {
    ...state,
    application: {
      ...state.application,
      errorMessage: null,
      loading: false,
      applicationId: action.payload.data.id,
      // clientId and clientSecret would need to be fetched separately
      clientId: null,
      clientSecret: null,
    },
  };
}

function createTerminalApplicationFailed(state, action) {
  if (
    action.payload &&
    action.payload[0] &&
    action.payload[0].response &&
    action.payload[0].response.text &&
    action.payload[0].response.text !== ""
  ) {
    const { text } = action.payload[0].response;
    return {
      ...state,
      application: {
        ...state.application,
        errorMessage: text,
        loading: false,
      },
    };
  }
  return {
    ...state,
    application: {
      ...state.application,
      errorMessage: "Something went wrong, try again later.",
      loading: false,
    },
  };
}

function terminalChangeActiveDirectory(state, action) {
  return {
    ...state,
    activeDirectory: action.payload,
  };
}

function setLoading(state) {
  return {
    ...state,
    loading: true,
  };
}

function createTerminalForumTopicSuccess(state, action) {
  const subject = action.payload.data.attributes.title;
  const body = action.payload.data.attributes.body.processed;
  return {
    ...state,
    forum_topic: {
      subject: subject,
      body: body,
    },
  };
}

function createTerminalForumTopicFailed(state) {
  return {
    ...state,
    loading: false,
    receiveStatus: false,
  };
}

export const terminalCommands = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.RESET_TERMINAL_APPLICATION]: resetTerminalApplication,
    [ActionTypes.CREATE_TERMINAL_APPLICATION]: createTerminalApplication,
    [ActionTypes.CREATE_TERMINAL_APPLICATION_SUCCESS]:
      createTerminalApplicationSuccess,
    [ActionTypes.CREATE_TERMINAL_APPLICATION_FAILED]:
      createTerminalApplicationFailed,
    [ActionTypes.TERMINAL_CHANGE_ACTIVE_DIRECTORY]:
      terminalChangeActiveDirectory,
    [ActionTypes.CREATE_TERMINAL_FORUM_TOPIC]: setLoading,
    [ActionTypes.CREATE_TERMINAL_FORUM_TOPIC_SUCCESS]:
      createTerminalForumTopicSuccess,
    [ActionTypes.CREATE_TERMINAL_FORUM_TOPIC_FAILED]:
      createTerminalForumTopicFailed,
  },
};
